import styled from "styled-components";

export const Container = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    
    width: 100%;
    z-index: 1000;

    background: rgba(58, 66, 76, 0.65);
    backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`;

export const Wrapper = styled.div`
    width: 100%;
    max-width: 1400px;

    height: 80px;

    margin: 0 auto;
    padding: 0 2rem;

    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
        padding: 0 1.5rem;
    }
`;

export const Logo = styled.a`
    color: ${({ theme }) => theme.colors.white};

    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -.5px;

    text-decoration: none;

    cursor: pointer;
`;

export const Menu = styled.nav`
    display: flex;
    align-items: center;
    gap: 2.5rem;

    @media (max-width: 992px) {
        display: none;
    }
`;

export const MenuItem = styled.a`
    color: ${({ theme }) => theme.colors.gray};

    text-decoration: none;

    font-size: .95rem;
    font-weight: 500;

    transition: color .3s ease;

    &:hover {
        color: ${({ theme }) => theme.colors.white};
    }
`;

export const Button = styled.button`
    padding: .85rem 1.5rem;

    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.md};

    background: ${({ theme }) => theme.colors.primary};

    color: ${({ theme }) => theme.colors.background};

    font-size: .95rem;
    font-weight: 600;

    cursor: pointer;

    transition:
        transform .3s ease,
        box-shadow .3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 30px rgba(127, 191, 208, .35);
    }

    @media (max-width: 992px) {
        display: none;
    }
`;

export const MobileButton = styled.button`
    display: none;

    align-items: center;
    justify-content: center;

    width: 44px;
    height: 44px;

    border: none;
    outline: none;

    background: transparent;

    color: ${({ theme }) => theme.colors.white};

    cursor: pointer;

    transition: color .3s ease;

    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }

    @media (max-width: 992px) {
        display: flex;
    }
`;

export const MobileMenu = styled.div`
    display: none;

    @media (max-width: 992px) {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        padding: 2rem;

        background: rgba(58, 66, 76, 0.98);
        backdrop-filter: blur(16px);

        border-top: 1px solid rgba(255, 255, 255, .06);
    }
`;

export const MobileMenuItem = styled.a`
    color: ${({ theme }) => theme.colors.white};

    text-decoration: none;

    font-size: 1rem;
    font-weight: 500;

    transition: color .3s ease;

    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const MobileButtonCTA = styled.a`
    display: flex;
    justify-content: center;

    width: 100%;

    

    padding: .85rem 1.5rem;

    border: none;
    border-radius: ${({ theme }) => theme.borderRadius.md};

    background: ${({ theme }) => theme.colors.primary};

    color: ${({ theme }) => theme.colors.background};

    font-size: .95rem;
    font-weight: 600;

    cursor: pointer;

    transition:
        transform .3s ease,
        box-shadow .3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 30px rgba(127, 191, 208, .35);
    }   
`;